import { fetchWithAuth } from '../utils/fetchWithAuth';



export const getAllCompanies = async () => {
  try {
    const response = await fetchWithAuth('/companies', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const getCompanie = async (name) => {
  try {
    const response = await fetchWithAuth(`/companies/${name}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const editCompanie = async (data) => {
  const { logo, ...payload } = data;
  try {
    const response = await fetchWithAuth(`/companies/${data.rut}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const createCompany = async (companyData) => {
  try {
    const formData = new FormData();
    formData.append('rut', companyData.rut);
    formData.append('business_name', companyData.business_name);
    formData.append('trade_name', companyData.trade_name);
    formData.append('industry', companyData.industry);
    formData.append('address', companyData.address);
    formData.append('region', companyData.region);
    formData.append('province', companyData.province);
    formData.append('district', companyData.district);
    formData.append('contact_email', companyData.contact_email);
    formData.append('password', companyData.password);
    formData.append('amount', parseFloat(companyData.amount));
    formData.append('periodicity', companyData.periodicity);
    formData.append('role', companyData.role);
    formData.append('status', companyData.status);
    formData.append('entry_date', companyData.entry_date);
    formData.append('company_size', companyData.company_size);

    if (companyData.landline_phone) formData.append('landline_phone', companyData.landline_phone);
    if (companyData.mobile_phone) formData.append('mobile_phone', companyData.mobile_phone);

    if (companyData.web_page) {
      const normalizedUrl = companyData.web_page.startsWith('http')
        ? companyData.web_page
        : `https://${companyData.web_page}`;
      formData.append('web_page', normalizedUrl);
    }

    if (companyData.description) formData.append('description', companyData.description);
    if (companyData.latitude) formData.append('latitude', parseFloat(companyData.latitude));
    if (companyData.longitude) formData.append('longitude', parseFloat(companyData.longitude));
    if (companyData.logo) formData.append('logo', companyData.logo);

    const contact = {
      contact_name: companyData.contact_name,
      email: companyData.email,
      phone_number: companyData.phone_number,
      title_job: companyData.title_job,
      area: companyData.area,
    };
    formData.append('contact', JSON.stringify(contact));

    const response = await fetchWithAuth('/companies/create', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Error al crear la empresa');
    }
    return await response.json();
  } catch (error) {
    console.error('Error en createCompany:', error);
    throw error;
  }
};

export const deleteCompany = async (companyRut) => {
  try {
    const response = await fetchWithAuth(`/companies/${companyRut}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error al eliminar la empresa:', error);
    throw error;
  }
};

export const updateByAdmin = async (companyData, rut) => {
  try {
    const response = await fetchWithAuth(`/companies/admin/${rut}`, {
      method: 'PATCH',
      body: companyData,
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error al actualizar la empresa:', error);
    throw error;
  }
};

export const changePassword = async (data) => {
  try {
    const response = await fetchWithAuth('/auth/update-password', {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error al cambiar la contraseña:', error);
    throw error;
  }
};

export const getImagesCompanies = async () => {
  try {
    const response = await fetchWithAuth('/companies/public/all-business-images', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      cache: 'no-store',
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const changeLogo = async (logo) => {
  try {
    const response = await fetchWithAuth(`/companies/logo/${localStorage.getItem('rut')}`, {
      method: 'PATCH',
      body: logo,
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error al cambiar el logo:', error);
    throw error;
  }
};

export const countCompanies = async () => {
  try {
    const response = await fetchWithAuth('/companies/count', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const fusionCompanies = async (data) => {
  try {
    const response = await fetchWithAuth('/companies/fusion', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error al fusionar empresas:', error);
    throw error;
  }
};

export const changeRut = async (rut, newRut) => {
  try {
    const response = await fetchWithAuth(`/companies/change/${rut}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ newRut }),
    });

    const data = await response.json();

    if (!response.ok) {
      const error = new Error(data.message || 'Ocurrió un error al cambiar el RUT');
      error.statusCode = response.status;
      error.backendData = data;
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Error al cambiar el RUT:', error);
    throw error;
  }
};
